import { createContext } from "react";

export interface AuditContextType {
  refetchAudits: () => void;
}

export const AuditContext = createContext<AuditContextType>(undefined!);
